import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: "AIzaSyCkWrxrhfAZFvMzzMKYe55JMgkvEu1UkVM",
  authDomain: "cobrapp-cf23b.firebaseapp.com",
  projectId: "cobrapp-cf23b",
  storageBucket: "cobrapp-cf23b.firebasestorage.app",
  messagingSenderId: "807673153757",
  appId: "1:807673153757:web:da4cfe4b63ed0ec7853334"
};

const app = initializeApp(firebaseConfig);

// Initialize App Check if site key is configured
const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
const disableAppCheckInDev = import.meta.env.VITE_DISABLE_APPCHECK_DEV === 'true';

if (siteKey && (!import.meta.env.DEV || !disableAppCheckInDev)) {
  if (import.meta.env.DEV) {
    (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(siteKey),
    isTokenAutoRefreshEnabled: true
  });
} else if (import.meta.env.DEV) {
  console.log("App Check omitido en desarrollo local para evitar bloqueos.");
}

const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };
